<shared-app-shell
  [navItems]="menuItems()"
  [showShell]="showAppShell()"
  [userEmail]="userService.user()?.email ?? null"
  (login)="login()"
  (logout)="logout()"
>
  <router-outlet (activate)="newRouteActivated($event)"></router-outlet>

  @if (showAppShell() && userService.user()?.role === "superuser") {
    <button
      shellAgentFab
      type="button"
      class="absolute bottom-6 right-6 z-50 flex h-8 w-8 items-center justify-center rounded-full bg-primary text-primary-contrast shadow-lg transition-all hover:brightness-110 active:scale-95"
      (click)="toggleAgentPanel()"
      [attr.aria-expanded]="agentPanelOpen()"
      aria-controls="app-agent-panel"
      [attr.aria-label]="
        agentPanelOpen() ? 'Close Tangi-Bot' : 'Open Tangi-Bot'
      "
    >
      <i
        class="text-md!"
        [ngClass]="agentPanelOpen() ? 'pi pi-times' : 'pi pi-sparkles'"
      ></i>
    </button>
  }

  @if (showAppShell() && userService.user()?.role === "superuser") {
    <aside
      shellAgentPanel
      id="app-agent-panel"
      class="shrink-0 h-full overflow-hidden transition-[width] duration-300 ease-out"
      [class.w-0]="!agentPanelOpen()"
      [class.w-80]="agentPanelOpen()"
      [class.pointer-events-none]="!agentPanelOpen()"
      [attr.aria-hidden]="!agentPanelOpen()"
    >
      <div
        class="h-full w-80 border-l border-surface-switch-200 bg-surface-switch-50"
      >
        <app-agent-drawer />
      </div>
    </aside>
  }
</shared-app-shell>
